import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CListGroup,
  CListGroupItem,
  CDataTable,
  CSpinner,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import NoData from "../../assets/imgs/no_data.svg";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/Loading";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";
import { simpleDateHour } from "../../helpers/date";

import "./style.css";

class Import extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selected: 0,
      sent: [],
      processed: [],
      logs: [],
      group: this.props.general.active_roles.group_id,
      groups: [],
      processing: null
    };

    this.filesRef = React.createRef();
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleGroups();
    this.handleSentFiles();
  }

  sortFiles(a, b) {
    const hierarchy = [
      "TURMASALUNOS",
      "TDP",
      "TURMASDISCIPLINAS",
      "ALUNOS",
      "PROFESSORES",
      "ADMINISTRATIVO",
      "TURMAS",
      "ESCOLAS",
      "REGIONAIS",
      "AULASLOS",
      "LOS",
      "AULAS",
      "MODULOS"
    ];
    const n = hierarchy.findIndex(item => item === a.type.toUpperCase());
    const m = hierarchy.findIndex(item => item === b.type.toUpperCase());

    return m - n;
  }

  handleSentFiles() {
    this.setState({ loading: true, selected: 0 });

    axios
      .get(`${URL.api}import/sent`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            sent: resp.data.data.sort(this.sortFiles),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  handleProcessedFiles() {
    this.setState({ loading: true, selected: 1 });

    axios
      .get(`${URL.api}import/processed`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ processed: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  handleLogs() {
    this.setState({ loading: true, selected: 2 });

    axios
      .get(`${URL.api}import/log`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            logs: resp.data.data.map(log => ({
              ...log,
              created_at: simpleDateHour(log.created_at)
            })),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  handleGroups() {
    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ groups: resp.data.data });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  onFilesAdded(e) {
    const files = [...e.target.files].filter(file =>
      file.name.endsWith(".csv")
    );

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(`file${i}`, files[i]);
    }

    axios
      .post(`${URL.api}import/send`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(
        resp => {
          this.handleSentFiles();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  removeSent(filename) {
    axios
      .post(
        `${URL.api}import/delete`,
        { name: filename },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          this.handleSentFiles();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  async processFiles() {
    if (this.state.group === null) {
      toastr.warning(
        "Selecione um grupo",
        "Para continuar, escolha um grupo para processar seus dados"
      );
      return;
    }

    for (const file of this.state.sent) {
      try {
        this.setState({ processing: file.original_name });

        await axios.post(
          `${URL.api}import/process/${file.original_name}`,
          { group_id: this.state.group },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        );

        this.setState(state => {
          const sent = state.sent.filter(
            item => item.original_name !== file.original_name
          );

          return { sent };
        });
      } catch (error) {
        this.error(error.response.statusText);
      }
    }

    this.setState({ processing: null });
  }

  render() {
    const { selected, loading, sent, processed, processing, logs } = this.state;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <div className="row m-0" style={{ flex: 1 }}>
          <div className="col-3 p-0">
            <CCard
              style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                height: "768px"
              }}
            >
              <CCardBody className="p-0 overflow-auto">
                <div
                  style={{ padding: "0.75rem 1.25rem" }}
                  className="text-muted bg-light"
                >
                  <i className="fa fa-rocket mr-2"></i> Visão Geral
                </div>
                <CListGroup>
                  <CListGroupItem
                    action
                    active={selected === 0}
                    className="import-list-item"
                    onClick={() => this.handleSentFiles()}
                  >
                    <i className="fa fa-file ml-3 mr-2"></i> Enviados
                  </CListGroupItem>
                  <CListGroupItem
                    action
                    active={selected === 1}
                    className="import-list-item"
                    onClick={() => this.handleProcessedFiles()}
                  >
                    <i className="fa fa-folder ml-3 mr-2"></i> Processados
                  </CListGroupItem>
                  <CListGroupItem
                    action
                    active={selected === 2}
                    className="import-list-item"
                    onClick={() => this.handleLogs()}
                  >
                    <i className="fa fa-list-ul ml-3 mr-2"></i> Log de processo
                  </CListGroupItem>
                </CListGroup>
                <div
                  style={{ padding: "0.75rem 1.25rem" }}
                  className="text-muted bg-light"
                >
                  <i className="fa fa-cloud-upload mr-2"></i> Enviar arquivo
                </div>
                <CListGroup>
                  <CListGroupItem
                    action
                    className="import-list-item"
                    style={{ borderRadius: 0 }}
                    onClick={() => this.filesRef.current.click()}
                  >
                    <i className="fa fa-rocket ml-3 mr-2"></i> Clique aqui para
                    enviar
                  </CListGroupItem>
                </CListGroup>
                <input
                  type="file"
                  name="files"
                  id="files"
                  className="d-none"
                  ref={this.filesRef}
                  onChange={e => this.onFilesAdded(e)}
                  multiple
                  accept=".csv"
                />
              </CCardBody>
            </CCard>
          </div>
          <div className="col-9 p-0">
            <CCard
              style={{
                borderLeft: 0,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                height: "768px"
              }}
            >
              {loading ? (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted">
                  <Loading />
                </CCardBody>
              ) : selected === 0 ? (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted p-0">
                  {sent.length === 0 ? (
                    <>
                      <img
                        src={NoData}
                        style={{
                          height: "200px",
                          marginBottom: "1.25rem",
                          opacity: 0.5
                        }}
                        alt=""
                      />
                      Nenhum arquivo a ser processado
                    </>
                  ) : (
                    <>
                      <div className="w-100 d-flex p-2 justify-content-between">
                        <CInputGroup className="w-auto">
                          <CInputGroupPrepend>
                            <CInputGroupText>Grupo</CInputGroupText>
                          </CInputGroupPrepend>
                          <CSelect
                            value={this.state.group}
                            onChange={e =>
                              this.setState({ group: e.target.value })
                            }
                            disabled={
                              this.props.general.active_roles.group_id !== null
                            }
                          >
                            <option value={null}>Selecione um grupo</option>
                            {this.state.groups.map(group => (
                              <option key={group.id} value={group.id}>
                                {group.name}
                              </option>
                            ))}
                          </CSelect>
                        </CInputGroup>
                        <CButton
                          color="primary"
                          onClick={() => this.processFiles()}
                        >
                          Processar tudo
                        </CButton>
                      </div>
                      <div className="flex-1 w-100 overflow-auto">
                        <CDataTable
                          addTableClasses="align-self-start"
                          items={sent}
                          fields={[
                            { key: "name", label: "Arquivo" },
                            { key: "created_at", label: "Data de criação" },
                            { key: "type", label: "Tipo" },
                            { key: "original_name", label: "Ações" }
                          ]}
                          scopedSlots={{
                            original_name: file => (
                              <td>
                                {processing === file.original_name ? (
                                  <CSpinner color="primary" size="sm" />
                                ) : processing !== null ? (
                                  <CSpinner color="light" size="sm" />
                                ) : (
                                  <CButton color="danger">
                                    <i
                                      className="fa fa-trash"
                                      onClick={() =>
                                        this.removeSent(file.original_name)
                                      }
                                    ></i>
                                  </CButton>
                                )}
                              </td>
                            )
                          }}
                        />
                      </div>
                    </>
                  )}
                </CCardBody>
              ) : selected === 1 ? (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted p-0">
                  {processed.length === 0 ? (
                    <>
                      <img
                        src={NoData}
                        style={{
                          height: "200px",
                          marginBottom: "1.25rem",
                          opacity: 0.5
                        }}
                        alt=""
                      />
                      Nenhum arquivo processado
                    </>
                  ) : (
                    <>
                      <div className="flex-1 w-100 overflow-auto">
                        <CDataTable
                          addTableClasses="align-self-start"
                          items={processed}
                          fields={[
                            { key: "name", label: "Arquivo" },
                            { key: "created_at", label: "Data de criação" },
                            { key: "type", label: "Tipo" }
                          ]}
                        />
                      </div>
                    </>
                  )}
                </CCardBody>
              ) : (
                <CCardBody className="justify-content-center align-items-center d-flex flex-column text-muted p-0">
                  {logs.length === 0 ? (
                    <>
                      <img
                        src={NoData}
                        style={{
                          height: "200px",
                          marginBottom: "1.25rem",
                          opacity: 0.5
                        }}
                        alt=""
                      />
                      Nenhum log encontrado
                    </>
                  ) : (
                    <>
                      <div className="flex-1 w-100 overflow-auto">
                        <CDataTable
                          addTableClasses="align-self-start"
                          items={logs}
                          fields={[
                            { key: "log", label: "Log" },
                            { key: "created_at", label: "Data de criação" }
                          ]}
                        />
                      </div>
                    </>
                  )}
                </CCardBody>
              )}
            </CCard>
          </div>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Import);
